import React, { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqData: FAQItem[] = [
    {
      question: "支払い方法は？",
      answer: "なつみ指定の場合は現金、クレジットカード、iD ,QUICPay決済がご利用いただけます。"
    },
    {
      question: "シャワーは使えますか？",
      answer: "ご利用いただけません。"
    },
    {
      question: "延長はできますか？",
      answer: "予約状況によりますが、可能な場合もございます。スタッフにご相談ください。"
    },
    {
      question: "時間に遅れた場合は時間は延長されますか？",
      answer: "遅れた場合でも終了時間は変更できませんので、ご了承ください。"
    },
    {
      question: "室内で着替えはできますか？",
      answer: "着替え可能です。"
    },
    {
      question: "電話での予約はできますか？",
      answer: "いいえ。予約はLINEからお願いいたします。"
    },
    {
      question: "スニーカーを忘れても大丈夫ですか？",
      answer: "はい。無料でご用意ございます。"
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="n-page n-faq">
      <header className="n-page-header">
        <div className="container">
          <span className="n-page-eyebrow">QUESTIONS & ANSWERS</span>
          <h1>FAQ</h1>
          <p>よくあるご質問</p>
        </div>
      </header>
      <section className="n-page-body">
        <div className="n-page-content">
          <div className="n-faq-list">
            {faqData.map((item, index) => (
              <article key={index} className={`n-faq-item ${openIndex === index ? 'active' : ''}`}>
                <button
                  type="button"
                  className="n-faq-question"
                  onClick={() => toggleFAQ(index)}
                  aria-expanded={openIndex === index}
                  aria-controls={`faq-answer-${index}`}
                >
                  <span className="n-faq-mark">Q</span>
                  <span>{item.question}</span>
                  <span className="n-faq-icon" aria-hidden="true">{openIndex === index ? '−' : '+'}</span>
                </button>
                <div className="n-faq-answer" id={`faq-answer-${index}`} hidden={openIndex !== index}>
                  <p><span>A</span>{item.answer}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;